import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { Observable } from 'rxjs';
import { TransportOrderIdView } from '../../../../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { getQueryStringFromObject } from '../../../../../common';
import { TransportationTrackingParty } from '../../../../../../lib/ui-kit';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderPartiesService {
  constructor(private http: WrapperHttpService) {}

  getParties(transportOrderIdView: TransportOrderIdView): Observable<TransportationTrackingParty[]> {
    return this.http
      .withLoading()
      .get<TransportationTrackingParty[]>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Parties
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
